<template>
  <a-tooltip>
    <template #title>{{ props.value.name || props.value.email }}</template>
    <div class="flex justify-center items-center w-full">
      <div
        class="profile_circle cursor-pointer w-7"
        :class="getProfileColor(userInitials)"
        @click="click"
      >
        <span class="text-sm font-normal opacity-60">
          {{ userInitials.toUpperCase() }}
        </span>
      </div>
    </div>
  </a-tooltip>
</template>
<script setup>
import { defineProps } from "vue";
import { getProfileColor, getUsernameInitials } from "@/src/utils/utils.js";
import eventBus from "@/src/utils/eventBus.js";

const props = defineProps({
  value: {
    type: Object,
    required: true,
  },
  row: {
    type: Object,
    required: true,
  },
});

const userInitials = getUsernameInitials(
  props.value.name || props.value.email || "",
);

const click = () => {
  eventBus.emit("emails/showActivity", props.row);
};
</script>
